import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SatPopoverModule } from '@ncstate/sat-popover';

import { SG_CLICK_CONFIRM_PLUGIN } from '../../../../click-confirm.service';
import { SgClickConfirmPopoverContainer } from './container.component';
import { SgClickConfirmPopoverPlugin } from './plugin';

@NgModule({
  imports: [CommonModule, SatPopoverModule],
  declarations: [SgClickConfirmPopoverContainer],
})
export class SgClickConfirmPopoverPluginModule {
  static readonly PLUGIN = SgClickConfirmPopoverPlugin;
}
